import { YesNoSwitch } from './YesNoSwitch';

export default YesNoSwitch;
